<template>
  <div class="table-responsive people-modal__table d-none d-lg-block">
    <table class="table table-bordered mb-0">
      <thead>
        <tr>
          <th class="align-middle" scope="col">
            Name
            <IconCaretDownFill v-if="sortBy == 'asc'" class="mb-1" />
            <IconCaretUpFill v-else class="mb-1" />
          </th>
          <th class="align-middle" scope="col">Role</th>
          <th class="align-middle" scope="col">Location</th>
          <th class="align-middle" scope="col">Contact</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in peopleModalStore.items" :key="item.id" @click="navigateTo(item.urlSlug)">
          <td class="align-middle people-modal__table__name">
            <div>
              <NuxtImg v-if="item.peopleImageUrl" :src="item.peopleImageUrl" />
              <span>{{ item.displayName }}</span>
            </div>
          </td>
          <td class="align-middle people-modal__table__role">
            <div>
              <p>{{ item.position?.[0] }}, {{ item.primaryCapability?.[0] }}</p>
            </div>
          </td>
          <td class="align-middle people-modal__table__location">
            <div>
              <p>{{ resolvedLocationRefs[item.id] }}</p>
            </div>
          </td>
          <td class="align-middle people-modal__table__contact">
            <div>
              <div>
                <IconPhone />
                <span v-html="item.phone" />
              </div>
              <div>
                <IconEmail />
                <span v-html="item.email" />
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="people-modal__list d-lg-none">
    <ul>
      <li v-for="(item, i) in peopleModalStore.items" :key="item.id">
        <div class="people-modal__list__item card">
          <NuxtImg v-if="item.peopleImageUrl" :src="item.peopleImageUrl" />
          <div class="people-modal__list__item__text">
            <span>{{ item.displayName }}</span>
            <span>{{ item.position?.[0] }}, {{ item.primaryCapability?.[0] }}</span>
            <span>{{
              resolvedLocationRefs[item.id]
            }}</span>
          </div>
          <div
            class="people-modal__list__item__toggle"
            data-bs-toggle="popover"
            tabindex="0"
            data-bs-trigger="focus"
            :data-bs-content="getPopoverContent(item)"
            @mousedown="closePopover(item.id, i)"
          >
            <IconDotsThreeVertical />
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import type { SearchResultPeopleItem } from '~/types/SearchResultItem'
import { usePeopleModalStore } from '~/stores/modals/people-modal'
import { useNuxtApp } from '#app'
import { createApp } from 'vue'
import ContactInfo from '../ContactInfo.vue'
import IconPhone from '~/components/icons/IconPhone.vue'
import IconEmail from '~/components/icons/IconEmail.vue'
import delay from 'lodash/delay'

const { $bsPopover } = useNuxtApp()
const peopleModalStore = usePeopleModalStore()
const { sortBy } = storeToRefs(peopleModalStore)
const popovers = ref<any[]>([])

const resolvedLocationRefs = ref<Record<string, string>>({})

const fetchLocation = async (item: SearchResultPeopleItem) => {
  if (item.location?.[0]) {
    return await peopleModalStore.getLocation(item.location[0])
  }
  return ''
}

const resolveLocations = async () => {
  for (let item of peopleModalStore.items) {
    resolvedLocationRefs.value[item.id] = await fetchLocation(item)
  }
}

onMounted(() => {
  resolveLocations()
  const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
  popovers.value = [...popoverTriggerList].map((popoverTriggerEl) =>
    $bsPopover(popoverTriggerEl, {
      container: '.people-modal__table',
      html: true,
      sanitize: false,
      placement: 'left',
      offset: [65, -50],
      trigger: 'focus'
    })
  )
})


const getPopoverContent = (item: SearchResultPeopleItem) => {
  const app = createApp(ContactInfo, {
    id: item.id,
    phone: item.phone,
    email: item.email
  })
    .component('IconPhone', IconPhone)
    .component('IconEmail', IconEmail)
  const container = document.createElement('div')
  app.mount(container)
  return container.innerHTML
}

const closePopover = (id: string, index: number) => {
  const popover = document.getElementById(`ci-${id}`)
  if (!popover) {
    (popovers.value[index] as any)?.show()
  } else {
    (popovers.value[index] as any)?.hide()
  }
}
</script>
